import { type CSSProperties, type ReactNode } from 'react';
import { clsx } from 'clsx';
import { badgeRoot, badgeRecipe } from './badge.css';

export type BadgeIntent = 'primary' | 'success' | 'warning' | 'danger';

export interface BadgeProps {
  badgeContent?: ReactNode;
  max?: number;
  invisible?: boolean;
  dot?: boolean;
  intent?: BadgeIntent;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function Badge({
  badgeContent,
  max = 99,
  invisible,
  dot = false,
  intent = 'primary',
  children,
  className,
  style,
}: BadgeProps) {
  const isEmpty = badgeContent === null || badgeContent === undefined || badgeContent === '';
  const isInvisible = invisible || (isEmpty && !dot);

  let display: ReactNode = badgeContent;
  if (!dot && typeof badgeContent === 'number' && max !== undefined && badgeContent > max) {
    display = `${max}+`;
  }

  return (
    <span className={clsx(badgeRoot, className)} style={style}>
      {children}
      <span
        className={badgeRecipe({
          intent,
          invisible: isInvisible,
          dot,
        })}
      >
        {!dot && display}
      </span>
    </span>
  );
}
